<template>
    <ThSelectPhoneCodes v-model:value="countryCode" />

    <TextField
        :id
        v-model="number"
        :error
        :label
        :placeholder
        :required
        type="tel"
    />
</template>

<script lang="ts" setup>
import TextField from '@/components/ui/inputs/TextField.vue'
import ThSelectPhoneCodes from '@/components/ui/inputs/ThSelectPhoneCodes.vue'

defineProps<{
    id: string
    error: string | undefined
    required?: boolean
    placeholder?: string
    label?: string
}>()

const countryCode = defineModel<string>('countryCode', { required: true })
const number = defineModel<string>('number', { required: true })
</script>
